import React, { Component, useState, useEffect } from "react";
import VerticalCarousel from "./VerticalCarousel";
import { config } from "@react-spring/web";
import { Link } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import LanguageContext from "../../context/LanguageContext";
import { getLocalizedFieldValue } from "../../utils/language";
import CloseIcon from "../../assets/images/icons/cross.svg";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import img1 from "../../assets/images/slider/slider1.jpg";
import img2 from "../../assets/images/slider/slider2.jpg";
import img3 from "../../assets/images/slider/slider3.jpg";

const buildMediaUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = (process.env.REACT_APP_API || "").replace(/\/+$/, "");
  if (!base) return path;
  const normalizedBase = base.replace(/\/v1$/i, "");
  return `${normalizedBase}/${path.replace(/^\/+/, "")}`;
};

let slides = [
    { key: 1, image: img1 },
    { key: 2, image: img2 },
    { key: 3, image: img3 },
];

export default class Example extends Component {

    state = {
        offsetRadius: 2,
        showNavigation: false,
        config: config.gentle,
        currentIndex: 0,
        quizzes: [],
        loading: false,
        language: "EN",
        isModalOpen: false,
        selectedGameUrl: "",
        iframeError: false,
        isMobile: window.matchMedia("(max-width: 767px)").matches,
    };

    componentDidMount() {
        // Get language from localStorage or default to EN
        const storedLang = localStorage.getItem("preferredLanguage") || "EN";
        this.setState({ language: storedLang });
        this.fetchQuizList();
        
        // Listen for language changes in localStorage
        window.addEventListener("storage", this.handleLanguageChange);
        // Also listen for custom event if language changes in same tab
        window.addEventListener("languageChange", this.handleLanguageChange);

        this.mediaQuery = window.matchMedia("(max-width: 767px)");
        this.handleMediaChange = (e) => {
            this.setState({ isMobile: e.matches });
        };
        this.mediaQuery.addEventListener("change", this.handleMediaChange);

        // ✅ ADDED
        this.enableBodyScrollOnCarousel();
    }

    enableBodyScrollOnCarousel = () => {
    if (!this.carouselTouchEl) return;

    this._onTouchMove = (e) => {
      // ✅ DO NOTHING — let browser scroll the body
      // absolutely no preventDefault
    };

    this.carouselTouchEl.addEventListener("touchmove", this._onTouchMove, {
      passive: true, // ✅ KEY
    });
  };

    componentWillUnmount() {
    window.removeEventListener("storage", this.handleLanguageChange);
    window.removeEventListener("languageChange", this.handleLanguageChange);

    if (this.mediaQuery && this.handleMediaChange) {
        this.mediaQuery.removeEventListener("change", this.handleMediaChange);
    }

    if (typeof this.disableBodyScrollOnCarousel === "function") {
        this.disableBodyScrollOnCarousel();
    }
    }

    disableBodyScrollOnCarousel = () => {
  if (this.carouselTouchEl && this._onTouchMove) {
    this.carouselTouchEl.removeEventListener(
      "touchmove",
      this._onTouchMove
    );
  }
};

    handleLanguageChange = () => {
        const storedLang = localStorage.getItem("preferredLanguage") || "EN";
        this.setState({ language: storedLang });
    };

    fetchQuizList = async () => {
        this.setState({ loading: true });
        try {
            const response = await handleApiCall("get", endpoints.quizList);
            if (
                response?.data?.code === 200 ||
                response?.data?.code === "200" ||
                response?.data?.success === true
            ) {
                const quizData = response?.data?.data?.data || [];
                // Filter only active quizzes (status === 1)
                const activeQuizzes = quizData.filter(quiz => quiz.status === 1);
                this.setState({ quizzes: activeQuizzes });
            } else {
                this.setState({ quizzes: [] });
            }
        } catch (error) {
            console.error("Error fetching quiz list:", error);
            this.setState({ quizzes: [] });
        } finally {
            this.setState({ loading: false });
        }
    };

    handleVerticalChange = (newIndex) => {
        this.setState({ currentIndex: newIndex });
        this.splide.go(newIndex);
    };

    handleSplideChange = (splide) => {
        this.setState({ currentIndex: splide.index });
    };

    handleQuizClick = (quiz) => {
        console.log("QUIZ OPEN:", quiz);
        if (quiz.game_type === "NORMAL" && quiz.game_url) {
            // Always try iframe modal first
            // Clear any existing timeout
            if (this.iframeTimeout) {
                clearTimeout(this.iframeTimeout);
                this.iframeTimeout = null;
            }
            this.setState({
                isModalOpen: true,
                selectedGameUrl: quiz.game_url,
                iframeError: false,
            });
            // Removed automatic timeout that opens new window - only show iframe popup
        }else{
            window.location.href = `/games-predictor?quizId=${quiz._id}`;
        }
        // For non-NORMAL types, the Link component will handle navigation
    };

    openModal = () => {
        this.setState({ isModalOpen: true });
    };

    closeModal = () => {
        if (this.iframeTimeout) {
            clearTimeout(this.iframeTimeout);
            this.iframeTimeout = null;
        }
        this.setState({ 
            isModalOpen: false,
            selectedGameUrl: "",
            iframeError: false,
        });
    };

    handleIframeError = () => {
        // Clear timeout if error handler is called
        if (this.iframeTimeout) {
            clearTimeout(this.iframeTimeout);
            this.iframeTimeout = null;
        }
        // If iframe fails to load, show error message with option to open in new window
        this.setState({ iframeError: true });
    };

    handleIframeLoad = () => {
        // Clear timeout if iframe loads successfully - don't auto-open new window
        if (this.iframeTimeout) {
            clearTimeout(this.iframeTimeout);
            this.iframeTimeout = null;
        }
        // Reset error state if iframe loads successfully
        this.setState({ iframeError: false });
    };

    handleOpenInNewWindow = () => {
        if (this.state.selectedGameUrl) {
            // Open in popup window with specific dimensions
            const width = 1200;
            const height = 800;
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2;
            
            const popup = window.open(
                this.state.selectedGameUrl,
                'gamePopup',
                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,status=no`
            );
            
            if (popup) {
                popup.focus();
            }
            this.closeModal();
        }
    };

    getQuizSlides = () => {
  const { quizzes, isMobile } = this.state;

  if (quizzes.length > 0) {
    return quizzes.map((quiz, index) => ({
      key: quiz._id || index + 1,
      quiz,
      image:
        buildMediaUrl(
          isMobile
            ? quiz.mobile_image || quiz.desktop_image
            : quiz.desktop_image || quiz.mobile_image
        ) ||
        slides[index % slides.length]?.image ||
        img1,
    }));
  }
  return slides;
};

    render() {
        const { quizzes, loading } = this.state;
        const quizSlides = this.getQuizSlides();
        const displayQuizzes = quizzes.length > 0 ? quizzes : [];

        return (
            <LanguageContext.Consumer>
                {({ language: contextLanguage }) => {
                    const currentLanguage = contextLanguage || this.state.language;
                    
                    // Get localized values for quizzes
                    const getQuizTitle = (quiz) => {
                        if (!quiz) return currentLanguage === "AR" ? "الألعاب والاختبارات" : "Games & Quizzes";
                        return getLocalizedFieldValue(quiz, currentLanguage, "main_title") || 
                               getLocalizedFieldValue(quiz, currentLanguage, "title") ||
                               (currentLanguage === "AR" ? "الألعاب والاختبارات" : "Games & Quizzes");
                    };

                    // Helper function to truncate text to 180 characters including "..."
                    const truncateDescription = (text) => {
                        if (!text) return "";
                        if (text.length > 180) {
                            return text.substring(0, 177) + "...";
                        }
                        return text;
                    };

                    const getQuizDescription = (quiz) => {
                        if (!quiz) return "";
                        const description = getLocalizedFieldValue(quiz, currentLanguage, "discription") || 
                                           getLocalizedFieldValue(quiz, currentLanguage, "description") || "";
                        return truncateDescription(description);
                    };
                    
                    return (
                        <>
                        <section className='
                            bg-white 
                            max-[767px]:[&_.pag-dots]:-left-[52px]
                            max-[767px]:[&_.pag-dots>.dots]:w-2 
                            max-[767px]:[&_.pag-dots>.dots]:h-[14px] 
                            max-[640px]:[&_.pag-dots]:hidden
                            '
                            id="games">
                            <div className="bg-[#0D0C0C] py-16 sm:py-10 md:py-16 [clip-path:polygon(0_0,_100%_0,100%_0%,_100%_88%,_90%_100%,_0%_100%)] md:[clip-path:polygon(0_0,_100%_0,100%_0%,_100%_80%,_90%_100%,_0%_100%)] lg:[clip-path:polygon(0_0,_100%_0,100%_0%,_100%_55%,_90%_100%,_0%_100%)]">
                                <div className='pt-4 pb-6 px-6 md:px-8 lg:px-8 2xl:px-0 max-w-8xl mx-auto flex flex-col'>
                                    <div className='max-w-[1268px] justify-center md:justify-between mx-auto flex flex-col gap-y-8 md:gap-y-0 sm:flex-row sm:gap-x-20 w-full md:w-auto px-4 md:px-0'>
                                        <div className='border border-white rounded-xl text-white text-center px-5 flex flex-col justify-center items-center [&_.splide\_\_slide]:flex [&_.splide\_\_slide]:items-center [&_.splide\_\_slide]:flex-col [&_.splide\_\_slide]:justify-center [&_.splide\_\_slide]:py-7 [&_.splide\_\_slide]:lg:py-16 w-full sm:w-[280px] md:w-[350px] lg:w-[458px] [&_.splide\_\_pagination]:hidden md:[&_.splide\_\_pagination]:block [&_.splide\_\_pagination]:right-[-128px] max-h-[280px] md:max-h-[400px] lg:max-h-[480px] 
                                        md:[&_.splide\_\_arrows]:hidden
                                        [&_.splide\_\_arrows>button]:!bg-transparent
                                        [&_.splide\_\_arrows>button]:!inset-x-0
                                        [&_.splide\_\_arrows>button]:mx-auto
                                        [&_.splide\_\_arrows>button]:translate-x-0
[&_.splide\_\_arrows>button>svg]:!fill-white
[&_.splide\_\_arrows>button>svg]:!text-[25px]
[&_.splide\_\_arrows>button>svg]:!opacity-50
[&_.splide\_\_arrows>button.splide\_\_arrow--prev]:top-0.5
[&_.splide\_\_arrows>button.splide\_\_arrow--next]:bottom-0.5 [&_.splide--slide]:w-full'>
                                            {loading ? (
                                                <div className="text-white text-center py-10">
                                                    {currentLanguage === "AR" ? "جاري التحميل..." : "Loading..."}
                                                </div>
                                            ) : displayQuizzes.length > 0 ? (
                                                <Splide
                                                    ref={(ref) => (this.splide = ref?.splide)}
                                                    options={{
                                                        rewind: true,
                                                        arrows: true,
                                                        pagination: false,
                                                        direction: 'ttb',
                                                        height: '480px',
                                                        
                                                        breakpoints: {
                                                            768: {
                                                                height: '280px',
                                                            },
                                                        },
                                                    }}
                                                    onMoved={this.handleSplideChange}
                                                    aria-label="Quiz List"
                                                >
                                                    {displayQuizzes.map((quiz, index) => (
                                                        <SplideSlide key={quiz._id || index}>
                                                            <h2 className={`md:text-[2rem] lg:text-[2.625rem] mb-2.5 md:mb-8 lg:mb-10 leading-tight ${currentLanguage === "AR" ? "font-SaudiaExtraBold text-[24px]" : "font-SaudiaBoldItalic text-[28px]"}`}>
                                                                {getQuizTitle(quiz)}
                                                            </h2>
                                                            <h3 className={`font-SaudiaExtraBold md:text-xl lg:text-2xl mb-3 md:mb-8 lg:mb-12 ${currentLanguage === "AR" ? "text-sm" : "text-base"}`}>
                                                                {getLocalizedFieldValue(quiz, currentLanguage, "title") || 
                                                                 (currentLanguage === "AR" ? "تطور في يديك" : "Evolution In Your Hands")}
                                                            </h3>
                                                            <div className={`text-xs md:text-base lg:text-lg font-SaudiaLight text-white md:leading-tight mb-4 md:mb-8 break-words ${currentLanguage === "AR" ? "leading-6" : ""}`}>
                                                                {getQuizDescription(quiz) || 
                                                                 truncateDescription(currentLanguage === "AR" 
                                                                     ? "ما مدى معرفتك بأجيال مختلفة من سيارة الفورمولا E؟ خذ اختبارنا التفاعلي ثلاثي الأبعاد وانظر أين ينتهي بك المطاف في لوحة المتصدرين العالمية للحصول على فرصة للفوز بجوائز!" 
                                                                     : "How well do you know the different Generations of the Formula E car? Take our immersive 3D quiz and see where you end up on the global leaderboard for the chance to win prizes!")}
                                                            </div>
                                                            {quiz.game_type === "NORMAL" && quiz.game_url ? (
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        e.nativeEvent.stopImmediatePropagation();
                                                                        this.handleQuizClick(quiz);
                                                                        return false;
                                                                    }}
                                                                    onMouseDown={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                    }}
                                                                    className={`bg-saudiaGreen md:min-h-11 min-h-8 w-[7rem] md:w-[8.875rem] text-center text-white inline-flex items-center justify-center rounded-md text-sm md:text-lg font-SaudiaLight cursor-pointer`}
                                                                >
                                                                    {currentLanguage === "AR" ? "العب الآن" : "Play Now"}
                                                                </button>
                                                            ) : (
                                                                <Link 
                                                                    to={`/games-predictor?quizId=${quiz._id}`}
                                                                    className='bg-saudiaGreen md:min-h-11 min-h-8 w-[7rem] md:w-[8.875rem] text-center text-white inline-flex items-center justify-center rounded-md text-sm md:text-lg font-SaudiaRegular'
                                                                >
                                                                    {currentLanguage === "AR" ? "العب الآن" : "Play Now"}
                                                                </Link>
                                                            )}
                                                        </SplideSlide>
                                                    ))}
                                                </Splide>
                                            ) : (
                                                <Splide
                                                    ref={(ref) => (this.splide = ref?.splide)}
                                                    options={{
                                                        rewind: true,
                                                        arrows: false,
                                                        pagination: false,
                                                        direction: 'ttb',
                                                        height: '480px',
                                                        breakpoints: {
                                                            768: {
                                                                height: '280px',
                                                            },
                                                        },
                                                    }}
                                                    onMoved={this.handleSplideChange}
                                                    aria-label="My Favorite Images"
                                                >
                                                    <SplideSlide>
                                                        <h2 className={`text-[28px] md:text-[2.625rem] mb-4 md:mb-10 ${currentLanguage === "AR" ? "font-SaudiaExtraBold" : "font-SaudiaBoldItalic"}`}>
                                                            {currentLanguage === "AR" ? "الألعاب والاختبارات" : "Games & Quizzes"}
                                                        </h2>
                                                        <h3 className='font-SaudiaExtraBold md:text-2xl mb-4 md:mb-12'>
                                                            {currentLanguage === "AR" ? "تطور في يديك" : "Evolution In Your Hands"}
                                                        </h3>
                                                        <div className='text-xs md:text-lg font-SaudiaLight text-white leading-tight mb-5 md:mb-8'>
                                                            {currentLanguage === "AR" 
                                                                ? "ما مدى معرفتك بأجيال مختلفة من سيارة الفورمولا E؟ خذ اختبارنا التفاعلي ثلاثي الأبعاد وانظر أين ينتهي بك المطاف في لوحة المتصدرين العالمية للحصول على فرصة للفوز بجوائز!" 
                                                                : "How well do you know the different Generations of the Formula E car? Take our immersive 3D quiz and see where you end up on the global leaderboard for the chance to win prizes!"}
                                                        </div>
                                                        <Link className='bg-saudiaGreen min-h-10 md:min-h-11 w-[8rem] md:w-[8.875rem] text-center text-white inline-flex items-center justify-center rounded-md text-base md:text-lg font-SaudiaLight'>
                                                            {currentLanguage === "AR" ? "يلعب" : "Play"}
                                                        </Link>
                                                    </SplideSlide>
                                                </Splide>
                                            )}
                                        </div>
                                        <div className="verticalSlider max-[639px]:-order-1 touch-pan-y" 
                                            ref={(el) => (this.carouselTouchEl = el)}
                                        >
                                            <div className="sm:w-[240px] md:w-[360px] xl:w-[450px] h-[300px] sm:h-[275px] md:h-[380px] lg:h-[465px] xl:h-[480px] relative flex flex-col justify-center">
                                                <VerticalCarousel
                                                    slides={quizSlides}
                                                    offsetRadius={this.state.offsetRadius}
                                                    showNavigation={this.state.showNavigation}
                                                    animationConfig={this.state.config}
                                                    currentIndex={this.state.currentIndex}
                                                    onIndexChange={this.handleVerticalChange}
                                                    onImageClick={this.handleQuizClick}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/*Popup Modal for NORMAL game type*/}
                        {this.state.isModalOpen && (
                            <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] px-20">
                                <button 
                                    onClick={this.closeModal} 
                                    className="absolute top-4 right-4 z-10 text-white text-xl hover:opacity-80 transition-opacity"
                                    aria-label={currentLanguage === "AR" ? "إغلاق" : "Close"}
                                >
                                    <img src={CloseIcon} alt={currentLanguage === "AR" ? "إغلاق" : "Close"} />
                                </button>
                                <div className="bg-white rounded-xl text-black relative lg:px-8 2xl:px-0 w-full h-[calc(100vh-50px)] max-w-8xl mx-auto">
                                    {this.state.iframeError ? (
                                        <div className="flex flex-col items-center justify-center h-full p-8 text-center">
                                            <p className="text-lg mb-4 text-gray-700">
                                                {currentLanguage === "AR" 
                                                    ? "تعذر تحميل اللعبة في هذه النافذة. يرجى النقر على الزر أدناه لفتحها في نافذة جديدة." 
                                                    : "Unable to load the game in this window. Please click the button below to open it in a new window."}
                                            </p>
                                            <button
                                                onClick={this.handleOpenInNewWindow}
                                                className="bg-saudiaGreen text-white px-6 py-2 rounded-md hover:bg-opacity-90 transition-opacity"
                                            >
                                                {currentLanguage === "AR" ? "فتح في نافذة جديدة" : "Open in New Window"}
                                            </button>
                                        </div>
                                    ) : (
                                        <iframe 
                                            src={this.state.selectedGameUrl} 
                                            width="100%" 
                                            height="100%"
                                            title={currentLanguage === "AR" ? "اللعبة" : "Game"}
                                            allow="fullscreen"
                                            className="border-0"
                                            onError={this.handleIframeError}
                                            onLoad={this.handleIframeLoad}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        </>
                    );
                }}
            </LanguageContext.Consumer>
        );
    }
}
